'use client'

import { createContext, Dispatch, FC, ReactNode, SetStateAction, useState } from 'react';

interface SoftCloseContextProps {
    newCloseCount: number;
    setNewCloseCount: Dispatch<SetStateAction<number>>;
}

const SoftCloseContext = createContext<SoftCloseContextProps | null>(null);

export const SoftCloseProvider: FC<{
    children: ReactNode
}> = ({
    children,
}) => {
        const [newCloseCount, setNewCloseCount] = useState<number>(0);

        return (
            <SoftCloseContext.Provider value={{
                newCloseCount,
                setNewCloseCount
            }}>
                {children}
            </SoftCloseContext.Provider>
        );
    };

export { SoftCloseContext };
